import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class NochesTerror extends Component {
  componentDidMount() {
    window.startx();
  }
  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>¡Prepárate para vivir una experiencia escalofriante en el Dinoparque!</h2>
          </header>
          <div className="containerimagenblog">
            <img className="imagenBlog" src="images/Blog/portada6.jpg" alt="Noches de Terror" />
          </div>
          <span className="containerblog">
              <div className="align justify">
                <p>
                Este 31 de octubre y 1 de noviembre, el Dinoparque se transforma en un escenario lleno de misterio, diversión y emociones intensas con nuestras <b>¡Noches de Terror!</b>
                </p>
                <p>
                  Ven con tu familia o amigos y atrévete a recorrer los senderos del parque mientras descubres criaturas sorprendentes, ambientes tenebrosos y muchas sorpresas más. 
                  Será una experiencia única donde la diversión y el suspenso se combinan para hacerte vivir una noche inolvidable.
                  </p>
                  <ul>
                    <li>
                      Horario: de 6:30 p.m. a 9:00 p.m.
                    </li>
                    <li>
                       Boletos: $49 por persona
                    </li>
                    <li>
                       Importante: la venta de boletos cierra a las 8:30 p.m., así que asegúrate de llegar a tiempo.
                    </li>
                  </ul>
                  <p>
                   Y recuerda… ¡No olvides venir disfrazado y traer tu linterna!
                   Te ayudará a descubrir los secretos más oscuros del parque… y quizá a escapar de alguna que otra sorpresa inesperada.
                   </p> 
                   <p>
                    Ya sea que vengas en familia, en pareja o con tu grupo de amigos valientes, te esperamos para disfrutar de una 
                    noche donde los dinosaurios cobran vida... ¡y el miedo también!
                    No lo pienses demasiado…
              
                  </p>
                  <p>
                    <b>Las Noches de Terror en Dinoparque son solo por dos fechas. ¡No te quedes fuera!</b>
                  </p>
                 

                
              <img className="izquierda" src="images/Blog/terror1.jpg" alt="terror1"/>
                <img className="imagenBlogmini" src="images/Blog/terror2.jpg" alt="terror2"/>
            </div>
            <div>
              <div className="containerjuego">
                 <Link className="button" to="/blog">
                Regresar
              </Link>
              </div>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default NochesTerror;